
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Leider ja. Deutlich erkannt wurde dieser Zusammenhang, weil einige der kleinen
«Harry Potter»-Leser bei der Lektüre der Abenteuer des berühmten Zauberers
erkrankten. Die Diagnose: Nacken- und Handgelenksschmerzen wegen starrer Haltung
und 2 bis 3 Tage dauernde Spannungskopfschmerzen durch unablässiges Lesen. Der
(augenzwinkernde) Fachausdruck dafür: «Hogwarts-Kopfweh.» Apropos Harry Potter:
An welcher Art von Kopfschmerzen der Zauber selbst litt, ist bis heute nicht
geklärt. Nadelscharfe Schmerzen, wie Feuer, explodierend, mit Sehstörungen und
Augentränen, manchmal auch mit Erbrechen – Migräne, diagnostizierten drei
amerikanische und britische Spezialisten. Sofort widersprachen zwei
US-Kinderneurologen, der Schmerztypus weise doch klar auf Nervenschmerzen hin.
Vermutlich habe sich an Harry Potters Stirnnarbe ein gutartiger Nerventumor
gebildet. Oder litt er an Neuralgie? Zu diesem Schluss kam ein norwegischer
Experte. Britische Spezialisten erkannten dagegen eine seltene
Bindegewebserkrankung. Wer sich an der Diskussion beteiligen will, sei auf die `}<Link href='https://ichd-3.org/de/' style={{
        whiteSpace: 'normal'
      }} mdxType="Link">{`«International
Classification of Headache Disorders»`}</Link>{` verwiesen. Dort sind alle bisher
bekannten Kopfschmerzarten aufgelistet, vom Kopfschmerz bei
Schilddrüsenunterfunktion bis zur «Hemicrania continua».`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;